import React from "react";
import { Reveal } from "@/components/motion/Reveal";

export function SectionLabel({ number, label, className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <span className="font-mono text-[11px] text-slate-400">{number}</span>
      <span className="h-px w-8 bg-slate-300" />
      <span className="label-mono text-slate-500">{label}</span>
    </div>
  );
}

export function SectionHeading({ children, className = "" }) {
  return (
    <h2 className={`mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900 ${className}`}>
      {children}
    </h2>
  );
}

export function SectionLead({ children, className = "" }) {
  return (
    <p className={`mt-5 text-base sm:text-lg text-slate-600 leading-relaxed max-w-2xl ${className}`}>
      {children}
    </p>
  );
}

export function SectionContainer({ id, children, className = "" }) {
  return (
    <section id={id} className={`relative border-b border-slate-200 py-20 sm:py-24 lg:py-28 ${className}`}>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>{children}</Reveal>
      </div>
    </section>
  );
}
